import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import React, { useEffect, useState } from "react";

import { DialogContent, IconButton } from "@material-ui/core";
import { Dialog } from "@mui/material";
import Typography from "@mui/material/Typography";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { addMonths, format } from "date-fns";
import "./MonthPicker.scss";

const MonthYearCalendar = (props) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedPickerDate, setSelectedPickerDate] = useState(new Date());
  const [openMonthPicker, setOpenMonthPicker] = useState(false);

  useEffect(() => {
    if(props.value){
      setSelectedDate(props.value);
      setSelectedPickerDate(props.value);
    }
  },[props.value])

  const handleMonthAndYearButtonClick = () => {
    setSelectedPickerDate(selectedDate);
    setOpenMonthPicker(true);
  };

  const handleMonthChange = (months) => {
    setSelectedDate(addMonths(selectedDate, months));
    props.onChange(addMonths(selectedDate, months));
  };

  const handleCalendarOnChange = (value, pickerState) => {
    if (pickerState === "finish") {
      setOpenMonthPicker(false);
      setSelectedDate(value);
      props.onChange(value);
    } else {
      setSelectedPickerDate(value);
    }
  };

  return (
    <div>
      <Typography variant="h6" className="month-headers">
        <div className="month-year-component">
          <IconButton
            className="navigation-button"
            onClick={() => handleMonthChange(-1)}
          >
            <ArrowBackIosIcon />
          </IconButton>
          <span
            className="picker-title"
            onClick={() => handleMonthAndYearButtonClick()}
          >
            {`${format(selectedDate, "MMMM yyyy")}`}
          </span>
          <IconButton
            className="navigation-button"
            onClick={() => handleMonthChange(1)}
          >
            <ArrowForwardIosIcon />
          </IconButton>
        </div>
      </Typography>
      <Dialog open={openMonthPicker} onClose={() => setOpenMonthPicker(false)}>
        <DialogContent>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateCalendar
              value={selectedPickerDate}
              onChange={(newValue, pickerState) =>
                handleCalendarOnChange(newValue, pickerState)
              }
              views={["year", "month"]}
              openTo="month"
            />
          </LocalizationProvider>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default MonthYearCalendar;
